/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Pharmacy15Inputs */

const en__field__enum_primarystudyinterest_study_pharmacy15 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Pharmacy15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pharmacy`)
};

const de__field__enum_primarystudyinterest_study_pharmacy15 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Pharmacy15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pharmazie`)
};

/**
* | output |
* | --- |
* | "Pharmacy" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Pharmacy15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_pharmacy15 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Pharmacy15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Pharmacy15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_pharmacy15(inputs)
	return de__field__enum_primarystudyinterest_study_pharmacy15(inputs)
});
export { _field__enum_primarystudyinterest_study_pharmacy15 as "_field__enum_primaryStudyInterest_STUDY_PHARMACY" }